  let tabHeadItemAll = document.querySelectorAll(".oy-tab-head-list-item")
        let tabHeadScrollbar = document.querySelector(".oy-line-scrollbar")
        let tabContentItemAll = document.querySelectorAll(".oy-tab-content-item")
        tabHeadItemAll.forEach((e, i) => {

            e.addEventListener("click", e2 => {
                tabHeadItemAll.forEach(e => {
                    e.classList.remove("active")
                })
                tabHeadItemAll[i].classList.add("active")
                console.log(e.offsetLeft + "px");
                console.log(e.offsetWidth);

                tabHeadScrollbar.style.left = e.offsetLeft - 279 + "px"
                tabHeadScrollbar.style.width = e.offsetWidth + "px"
                tabContentItemAll.forEach(e => {
                    e.classList.remove("active")
                })
                tabContentItemAll[i].classList.add("active")
            })
        })




document.querySelector(".oy-tab-content-item").classList.add("active")